import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { IconInput } from 'shared/components/molecules/IconInput/IconInput';
import { Checkbox } from 'shared/components/molecules/Checkbox/Checkbox';
import { Button } from 'shared/components/atoms/Button/Button';
import { Modal } from 'shared/components/organisms/Modal/Modal';

import { emailValidation } from 'utils/format';
import api from 'services/api';
import { AuthContext } from 'contexts/auth';

import mail from 'assets/icons/mail.svg';
import filled_mail from 'assets/icons/filled_mail.svg';
import locker from 'assets/icons/locker.svg';
import filled_locker from 'assets/icons/filled_locker.svg';

import {
  Container,
  FieldsWrapper,
  LeftBottom,
  LeftCenter,
  LeftTop,
  RegisterWrapper,
  RepfyLogo,
  RightBottom,
  RightTop,
} from './_login';
import { toast } from 'react-toastify';

export const Login: React.FC = () => {
  const history = useHistory();

  const { signIn, rememberUser, setRememberUser } = useContext(AuthContext);

  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleLogin = async () => {
    setLoading(true);

    const user = {
      email: email.trim(),
      password: password,
    };

    try {
      await signIn(user);

      history.push('/')
    } catch (error: any) {
      toast.error(error?.response?.data?.message);

      if(error?.response?.status === 300) {
        history.push('/cadastro?confirmOnly=true')
      }
    } finally {
      setLoading(false);
    }
  };

  const disabled = () => {
    return !emailValidation(email) || password.length < 6 || loading
      ? true
      : false;
  };

  return (
    <Container>
      <LeftTop />

      <LeftCenter />

      <LeftBottom />

      <RegisterWrapper>
        <RepfyLogo />

        <h1>Prestadores</h1>

        <FieldsWrapper>
          <div className="fields-wrapper__info">
            <span className="fields-wrapper__info__title">Bem vindo!</span>
            <p className="fields-wrapper__info__call">Fazer login</p>
          </div>

          <div className="group__wrapper">
            <IconInput
              icon={mail}
              activeIcon={filled_mail}
              inputValue={email}
              type="email"
              setInputValue={setEmail}
              placeholder={'Email'}
            />

            <IconInput
              icon={locker}
              activeIcon={filled_locker}
              inputValue={password}
              type="password"
              setInputValue={setPassword}
              placeholder={'Senha'}
            />
          </div>

          <span
            className="fields-wrapper__forgot-password"
            onClick={() => history.push('alterar-senha')}
          >
            Esqueceu a senha?
          </span>

          <Checkbox checked={rememberUser} setChecked={setRememberUser}>
            Salvar dados de login
          </Checkbox>

          <Button disabled={disabled()} onClick={() => handleLogin()}>
            Entrar
          </Button>

          <div className="fields-wrapper__register">
            É novo aqui?{' '}
            <b onClick={() => history.push('cadastro')}> Cadastre-se</b>
          </div>
        </FieldsWrapper>
      </RegisterWrapper>

      <Modal showModal={showModal} setShowModal={setShowModal}></Modal>

      <RightTop />

      <RightBottom />
    </Container>
  );
};
